module.exports = __webpack_public_path__ + "static/media/card-blue-icon.2498c752.svg";